define('drops/googleMap/googleMap',[
    'jquery',
    'when',
    'uuid',
    'lq',
    'lq/frontendModules',
    'lq/drop',
    'lq/dispatcher',
    'lq/style'
], function ($, when, uuid, lq, FrontendModules, Drop, dispatcher, Style) {
    "use strict";

    var defaults = {
        data: {
            zoom: 13,
            selectedlocationOption: "hard coded",
            address: "Palm Jumeirah",
            mapType: "roadmap",
            mapStyle: 'default',
            draggableMarkers: true,
            size: { x: 500, y: 500 },
            zoomAddr: 13,
            zoomCoor: 13,
            estimateDraggedAddress: false,
            unknownAddressText: "Unknown address",
            backgroundColor: "#ea4335",
            borderColor: "#b31412",
            glyphColor: "#b31412",
            defaultMarkerScale: 1,
        },
    };
    
    var geoLocationRegex = /[(](-?[0-9]*.[0-9]*)[,][ ](-?[0-9]*.[0-9]*)[)]/;

    var mapIds = {
        plain: '3409f9b959a3719b'
    }
    var markers = [];

    function GoogleMap(options) {
        Drop.call(this, $("<div/>"), defaults, options);

        this.$map = $("<div />")
            .attr("id", "map-canvas")
            .css({
                width: "100%",
                height: "100%",
                visibility: "inherit",
            })
            .appendTo(this.$element);

        this.$element.addClass("boxToBorderSize").css({
            whiteSpace: "pre-wrap",
        });

        this.mapDeferred = when.defer();

        Style.renderStyles(this);
    };

    Drop.extend(GoogleMap, Drop);

    GoogleMap.typeName = "GoogleMap";

    GoogleMap.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        
        var deferred = when.defer();
        this.loadModule(deferred);
        return deferred.promise;
    };

    GoogleMap.prototype.loadModule = function (deferred) {
        var self = this;

        FrontendModules.load("googleMap", false).then(function (module) {
            module
                .loadGoogleMapsLibraries({
                    libraryNames: ["maps", "marker"],
                    url: lq.getTenantUrl("GoogleMaps/FetchApiKey"),
                    actionId: self.piping.actionId,
                    dropId: self.data.id,
                })
                .then(function () {
                    // Libraries are loaded, initialize the map and resolve the defer
                    self.initMap();
                    deferred.resolve();
                });
        });
    };

    GoogleMap.prototype.initMap = function () {
        this.createGoogleMap();
        if (this.isEventEnabled("locationSelected")) {
            this.addClickEventListenerToMap();
        }
        this.renderMap();
    };

    GoogleMap.prototype.getMapId = function () {
        var style = this.data.mapStyle;
        if (style === 'custom' && this.data.customStyleMapId) return this.data.customStyleMapId;
        return mapIds[style] || this.data.id + '-' + Math.floor(Math.random() * 10000).toString();
    };

    GoogleMap.prototype.createGoogleMap = function () {
        var myOptions = {
            mapTypeId: this.getMapType(this.data.mapType),
            mapId: this.getMapId()
        };

        this.basePinElementOptions = { scale: this.data.defaultMarkerScale };
        if (this.data.useCustomBaseMarkerColors) {
            this.basePinElementOptions = Object.assign({}, this.basePinElementOptions);
            this.basePinElementOptions.background = this.data.backgroundColor;
            this.basePinElementOptions.borderColor = this.data.borderColor;
            this.basePinElementOptions.glyphColor = this.data.glyphColor;
        }

        if (!this.map) {
            this.map = new window.google.maps.Map(this.$map.get(0), myOptions);
            this.pointerEventsBlocked = true;
            this.$map.css("pointer-events", "none");
        }
    };

    GoogleMap.prototype.addClickEventListenerToMap = function () {
        var self = this;

        window.google.maps.event.addListener(this.map, "click", function (event) {
            if (self.data.latParam) {
                self.piping.parameters.locals.setValue(self.data.latParam, event.latLng.lat());
            }
            if (self.data.lngParam) {
                self.piping.parameters.locals.setValue(self.data.lngParam, event.latLng.lng());
            }
            if (self.data.addressParam) {
                dispatcher
                    .dispatch("GoogleMaps/Geocode", {
                        actionId: self.piping.actionId,
                        dropId: self.data.id,
                        lat: event.latLng.lat(),
                        lng: event.latLng.lng(),
                    })
                    .then(function (response) {
                        if (response.success) {
                            if (response.formatted_address) {
                                self.piping.parameters.locals.setValue(
                                    self.data.addressParam,
                                    response.formatted_address
                                );
                                self.triggerEventIfEnabled("locationSelected");
                            }
                        } else {
                            alert(
                                "Failed the geocoding of the following lat lng values: " +
                                    event.latLng.lat() +
                                    " " +
                                    event.latLng.lng() +
                                    ".\nLeave the 'Address parameter' empty in the designer to skip the geocoding."
                            );
                        }
                    });
            } else {
                self.triggerEventIfEnabled("locationSelected");
            }
        });
    };

    GoogleMap.prototype.renderMap = function () {
        var self = this;
        if (this.data.selectedlocationOption === 'hard coded') {
            if (this.data.address) {
                this.goToAddress(this.data.address);
            }
            else if (this.data.lat && this.data.lng) {
                this.goToCoordinates(this.data);
            }
        } else if (this.data.selectedlocationOption === "datasource addresses") {
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                self.deleteMarkers(self.map);
                if (data.results.length !== 0) {
                    for (var i = 0; i < data.results.length; i++) {
                        var resultAddress = data.results[i][self.data.addressOutput];
                        
                        if (resultAddress != null) {
                            dispatcher
                                .dispatch("GoogleMaps/Geocode", {
                                    actionId: self.piping.actionId,
                                    dropId: self.data.id,
                                    address: resultAddress,
                                })
                                .then(self.forwardGeoCode.bind(self, data.results[i]));
                        }
                    }
                } else {
                    self.setDefaults(self.map);
                }
            });
        } else if (this.data.selectedlocationOption === "datasource coordinates") {
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                self.deleteMarkers(self.map);
                var onlyNullFlag = true;
                for (var i = 0; i < data.results.length; i++) {
                    if (data.results[i][self.data.latOutput] && data.results[i][self.data.lngOutput]) {
                        onlyNullFlag = false;
                        var marker = self.createMarker(data.results[i]);
                        window.google.maps.event.addListener(
                            marker,
                            "click",
                            self.markerClicked.bind(self, data.results[i])
                        );
                        if (self.data.draggableMarkers)
                            window.google.maps.event.addListener(
                                marker,
                                "dragend",
                                self.markerDragged.bind(self, data.results[i])
                            );
                    }
                }
                if (onlyNullFlag) {
                    self.setDefaults(self.map);
                } else {
                    self.calculateMarkerBounds(self.map);
                }
            });
        }
        this.mapDeferred.resolve(this.map);
    };

    GoogleMap.prototype.clearValue = $.noop;

    GoogleMap.prototype.setValue = function (data) {
        this.goToLocation(data.value);
    };

    GoogleMap.prototype.goToLocation = function (value) {
        var self = this;
        if (self.data.selectedlocationOption === "query address") {
            self.goToAddress(value);
        } else if (self.data.selectedlocationOption === "query coordinates") {
            self.goToCoordinates(value);
        }
    };

    GoogleMap.prototype.goToCoordinates = function (coordinates) {
        var self = this;

        try {
            if (coordinates.lat !== undefined && coordinates.lng !== undefined) {
                self.renderValue(coordinates);
            } else {
                var seperator = coordinates.indexOf(";");
                if (seperator != -1) {
                    var slat = coordinates.substring(0, seperator);
                    var slng = coordinates.substring(seperator + 1);
                    var flat = parseFloat(slat);
                    var flng = parseFloat(slng);
                    if (flat < 85 && flat > -85 && flng < 180 && flng > -180) {
                        self.renderValue({
                            lat: flat,
                            lng: flng,
                        });
                    }
                }
            }
        } catch (e) {}
    };

    GoogleMap.prototype.goToAddress = function (address) {
        var self = this;
        
        dispatcher
            .dispatch("GoogleMaps/Geocode", {
                actionId: self.piping.actionId,
                dropId: self.data.id,
                address: address,
            })
            .then(function (response) {
                if (response.status == 'OK') {
                    var locationCoordinates = `(${response.lat}, ${response.lng})`;
                    var result = geoLocationRegex.exec(locationCoordinates);
                    if (result.length >= 3) {
                        self.renderValue({
                            lat: result[1],
                            lng: result[2],
                        });
                    }
                } else if (["query address", "query coordinates"].includes(self.data.selectedlocationOption)) {
                    self.triggerEventIfEnabled("unknownMapping")
                };
            });
    };

    GoogleMap.prototype.renderValue = function (data) {
        var self = this;

        var latlng = new window.google.maps.LatLng(data.lat, data.lng);

        var myOptions = {
            zoom: this.data.zoom,
            center: latlng,
            mapTypeId: this.getMapType(self.data.mapType),
        };

        this.map.setOptions(myOptions);

        var marker = self.createMarker(undefined, latlng);
        data.eventArg = uuid();
        
        window.google.maps.event.addListener(marker, "click", self.markerClicked.bind(self, data));
        
        if (this.data.draggableMarkers) {
            window.google.maps.event.addListener(marker, "dragend", self.markerDragged.bind(self, data));
        }
        
        if (this.data.mappedMarkerId) {
            this.piping.parameters.locals.setValue(this.data.mappedMarkerId, data.eventArg);
        }

        this.unblockPointerEvents();
    };

    GoogleMap.prototype.getMapType = function (mapType) {
        switch (mapType) {
            case "terrain":
                return window.google.maps.MapTypeId.TERRAIN;
            case "satellite":
                return window.google.maps.MapTypeId.SATELLITE;
            case "hybrid":
                return window.google.maps.MapTypeId.HYBRID;
            default:
                return window.google.maps.MapTypeId.ROADMAP;
        }
    };

    GoogleMap.prototype.markerClicked = function (markerData) {
        this.triggerEventIfEnabled("clicked", markerData[this.data.eventArg] || markerData.eventArg);
    };

    GoogleMap.prototype.geocodePosition = function (lat, lng, writeParam) {
        var self = this;
        var deferred = $.Deferred();

        dispatcher
            .dispatch("GoogleMaps/Geocode", {
                actionId: self.piping.actionId,
                dropId: self.data.id,
                lat: lat,
                lng: lng,
            })
            .then(function (response) {
                if (
                    response.status === 'OK' &&
                    response.status !== 'ZERO_RESULTS'
                ) {
                    self.piping.parameters.locals.setValue(writeParam, response.formatted_address);
                } else {
                    self.piping.parameters.locals.setValue(writeParam, self.data.unknownAddressText);
                }
                deferred.resolve();
            });

        return deferred.promise();
    };

    GoogleMap.prototype.markerDragged = async function (markerData, marker) {
        var self = this;
        if (this.data.draggedLatParam && this.data.draggedLngParam) {
            this.piping.parameters.locals.setValue(this.data.draggedLatParam, marker.latLng.lat());
            this.piping.parameters.locals.setValue(this.data.draggedLngParam, marker.latLng.lng());
        }

        if (this.data.estimateDraggedAddress && this.data.draggedAddressParam) {
            this.geocodePosition(marker.latLng.lat(), marker.latLng.lng(), this.data.draggedAddressParam).done(
                function () {
                    self.triggerEventIfEnabled("pinDragged", markerData[self.data.eventArg] || markerData.eventArg);
                }
            );
        } else {
            self.triggerEventIfEnabled("pinDragged", markerData[self.data.eventArg] || markerData.eventArg)
        };
    };

    GoogleMap.prototype.forwardGeoCode = function (markerData, response) {
        var self = this;

        if (response.status === 'OK') {
            var locationCoordinates = `(${response.lat}, ${response.lng})`;
            var result = geoLocationRegex.exec(locationCoordinates);

            if (result.length >= 3) {
                var marker = self.createMarker(markerData, new window.google.maps.LatLng(result[1], result[2]));
                window.google.maps.event.addListener(marker, "click", self.markerClicked.bind(self, markerData));
                if (self.data.draggableMarkers)
                    window.google.maps.event.addListener(
                        marker,
                        "dragend",
                        self.markerDragged.bind(self, markerData, marker)
                    );
            }
            self.calculateMarkerBounds(self.map);
        } else if (markers.length === 0) {
            this.setDefaults(this.map);
        }
    };

    GoogleMap.prototype.setDefaults = function (map) {
        var self = this;
        var lat, lng, address, zooom, isVisible;

        if (this.data.selectedlocationOption === "datasource addresses") {
            isVisible = this.data.showMapAddr;
            lat = parseFloat(this.data.latAddr);
            lng = parseFloat(this.data.lngAddr);
            address = this.data.addressAddr;
            zooom = this.data.zoomAddr;
        } else if (this.data.selectedlocationOption === "datasource coordinates") {
            isVisible = this.data.showMapCoor;
            lat = parseFloat(this.data.latCoor);
            lng = parseFloat(this.data.lngCoor);
            address = this.data.addressCoor;
            zooom = this.data.zoomCoor;
        }

        this.deleteMarkers(map);

        if (!isVisible) {
            // this.$map.css({
            //     visibility: 'hidden'
            // })
            return;
        }
        if (address) {
            dispatcher
                .dispatch("GoogleMaps/Geocode", {
                    actionId: self.piping.actionId,
                    dropId: self.data.id,
                    address: address,
                })
                .then(function (response) {
                    if (response.status === 'OK') {
                        var locationCoordinates = `(${response.lat}, ${response.lng})`;
                        var result = geoLocationRegex.exec(locationCoordinates);
                        if (result.length >= 3) {
                            var latlng = new window.google.maps.LatLng(result[1], result[2]);
                            map.setCenter(latlng);
                            map.setZoom(zooom);
                        }
                    }
                });
        } else if (lat && lng) {
            map.setCenter({ lat: lat, lng: lng });
            map.setZoom(zooom);
        } else {
            // If no address and lat-lng values are given, sets the map's center on Belgium.
            map.setCenter({ lat: 50.503887, lng: 4.469936 });
            map.setZoom(7);
        }

        this.unblockPointerEvents();
    };

    GoogleMap.prototype.deleteMarkers = function () {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }

        markers = [];
    };

    GoogleMap.prototype.calculateMarkerBounds = function (map) {
        if (markers.length === 1) {
            map.setCenter(markers[0].position);
            map.setZoom(14); // Default zoom if database has only one value.
        } else if (markers.length !== 0) {
            var markerBounds = new window.google.maps.LatLngBounds();
            
            for (var i = 0; i < markers.length; i++) {
                markerBounds.extend(markers[i].position);
            }

            map.fitBounds(markerBounds);
        }
        this.unblockPointerEvents();
    };

    GoogleMap.prototype.getMap = function () {
        return this.mapDeferred.promise;
    };

    GoogleMap.prototype.licquidMethod_deleteMarkers = function () {
        this.deleteMarkers();
    };

    GoogleMap.prototype.unblockPointerEvents = function () {
        if (this.pointerEventsBlocked) {
            this.pointerEventsBlocked = false;
            this.$map.css("pointer-events", "");
        }
    };

    GoogleMap.prototype.createMarker = function (markerData, latlng) {
        if (!latlng && (!markerData[this.data.latOutput] || !markerData[this.data.lngOutput])) 
            return;

        var marker = new window.google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: latlng || new window.google.maps.LatLng(markerData[this.data.latOutput], markerData[this.data.lngOutput]),
            draggable: this.data.draggableMarkers,
        });

        var pinElementOptions = Object.assign({}, this.basePinElementOptions);

        if (markerData) {
            if (this.data.useDynamicMarkerColorsFromDatasource) {
                pinElementOptions.background = markerData[this.data.backgroundColorOutput] || pinElementOptions.background;
                pinElementOptions.borderColor = markerData[this.data.borderColorOutput] || pinElementOptions.borderColor;
                pinElementOptions.glyphColor = markerData[this.data.glyphColorOutput] || pinElementOptions.glyphColor;
            }

            if (this.data.markerScaleOutput) {
                pinElementOptions.scale = markerData[this.data.markerScaleOutput] || pinElementOptions.scale;
            }

            if (this.data.markerTitleOutput) {
                marker.title = markerData[this.data.markerTitleOutput];
            } 
        }

        marker.content = new window.google.maps.marker.PinElement(pinElementOptions).element;
        markers.push(marker);

        return marker;
    };

    return GoogleMap;
});

